import { SessionState } from './types';

export type WsStateMessage = {
  type: 'state';
  seriesId: string;
  revision?: number;
  state?: SessionState;
  senderId?: string;
  meetingId?: string;
};

export type WsLegacyMessage = {
  meetingId: string;
  senderId: string;
  valuesToUpdate?: unknown;
};

export const parseWsMessage = (data: string): WsStateMessage | WsLegacyMessage | null => {
  try {
    return JSON.parse(data) as WsStateMessage | WsLegacyMessage;
  } catch {
    return null;
  }
};

export const sendWsJoin = (
  ws: WebSocket,
  seriesId: string,
  clientId: string
): void => {
  if (ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({ type: 'join', seriesId, clientId }));
  }
};

export const sendWsPing = (ws: WebSocket): void => {
  if (ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({ type: 'ping' }));
  }
};
